import { ensureItemsModalState } from './state.js';

export function initializeItemsModalEvents() {
    const state = ensureItemsModalState(this);
    if (state.eventsInitialized) {
        return;
    }

    const listContainer = document.getElementById('items-list');
    const selectAllCheckbox = document.getElementById('select-all-items');
    const bulkDeleteBtn = document.getElementById('bulk-delete-btn');
    const searchInput = document.getElementById('search-items-input');
    const clearSearchBtn = document.getElementById('clear-search');

    this.boundHandleItemsClick = this.boundHandleItemsClick || ((event) => this.handleItemsListClick(event));
    this.boundHandleItemsChange = this.boundHandleItemsChange || ((event) => this.handleItemsListChange(event));
    this.boundHandleSelectAll = this.boundHandleSelectAll || ((event) => this.handleSelectAllItems(event));
    this.boundHandleBulkDelete = this.boundHandleBulkDelete || (() => this.handleBulkDelete());
    this.boundHandleSearchInput = this.boundHandleSearchInput || ((event) => this.handleItemsSearchInput(event));
    this.boundHandleSearchKeydown = this.boundHandleSearchKeydown || ((event) => this.handleItemsSearchKeydown(event));
    this.boundHandleClearSearch = this.boundHandleClearSearch || (() => this.handleClearSearch());

    listContainer?.addEventListener('click', this.boundHandleItemsClick);
    listContainer?.addEventListener('change', this.boundHandleItemsChange);
    selectAllCheckbox?.addEventListener('change', this.boundHandleSelectAll);
    bulkDeleteBtn?.addEventListener('click', this.boundHandleBulkDelete);
    searchInput?.addEventListener('input', this.boundHandleSearchInput);
    searchInput?.addEventListener('keydown', this.boundHandleSearchKeydown);
    clearSearchBtn?.addEventListener('click', this.boundHandleClearSearch);

    state.eventsInitialized = true;
}

